import { render, staticRenderFns } from "./PropertyMaintenanceSystemDetail.vue?vue&type=template&id=2ad8d67c"
import script from "./PropertyMaintenanceSystemDetail.vue?vue&type=script&lang=ts"
export * from "./PropertyMaintenanceSystemDetail.vue?vue&type=script&lang=ts"
import style0 from "./PropertyMaintenanceSystemDetail.vue?vue&type=style&index=0&id=2ad8d67c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports